import { AXIS_LABEL_FONT_SIZE } from '../../consts';
export const inlineStyles = {
    axisScaleLabel: {
        fontSize: `${AXIS_LABEL_FONT_SIZE}px`,
        transform: 'translateY(6px)',
    },
};
